import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "toast-container",
  "aria-live": "polite",
  "aria-atomic": "false"
}
const _hoisted_2 = { class: "toast-icon" }
const _hoisted_3 = { class: "toast-message" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "toast-progress" }

import { useToast } from '@/composables/ui/useToast'
import { CheckCircle2, XCircle, AlertTriangle, Info, X } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseToast',
  setup(__props) {

const { toasts, dismiss } = useToast()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "toast",
        tag: "div",
        class: "toast-stack"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (t) => {
            return (_openBlock(), _createElementBlock("div", {
              key: t.id,
              class: _normalizeClass(["toast-item", `toast--${t.variant}`]),
              role: "status"
            }, [
              _createElementVNode("span", _hoisted_2, [
                (t.variant === 'success')
                  ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (t.variant === 'error')
                    ? (_openBlock(), _createBlock(_unref(XCircle), {
                        key: 1,
                        class: "h-5 w-5"
                      }))
                    : (t.variant === 'warning')
                      ? (_openBlock(), _createBlock(_unref(AlertTriangle), {
                          key: 2,
                          class: "h-5 w-5"
                        }))
                      : (_openBlock(), _createBlock(_unref(Info), {
                          key: 3,
                          class: "h-5 w-5"
                        }))
              ]),
              _createElementVNode("p", _hoisted_3, _toDisplayString(t.message), 1),
              _createElementVNode("button", {
                class: "toast-close",
                onClick: ($event: any) => (_unref(dismiss)(t.id)),
                "aria-label": "Dismiss"
              }, [
                _createVNode(_unref(X), { class: "h-4 w-4" })
              ], 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["toast-progress-bar", `toast-progress-bar--${t.variant}`]),
                  style: _normalizeStyle({ animationDuration: `${t.duration}ms` })
                }, null, 6)
              ])
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})